//异常数据
import _import from '@/utils/import'
const Layout = _import('layout/Layout')
let freight = [
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'carVehicle', //货运平台车辆数统计
        component: _import('freight/carVehicle/index'),
        name: 'carVehicle',
        meta: {
          title: '货运平台车辆数统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carTrain', //途经运营车次数统计
        component: _import('freight/carTrain/index'),
        name: 'carTrain',
        meta: {
          title: '途经运营车次数统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carStop', //途径油站停靠次数统计
        component: _import('freight/carStop/index'),
        name: 'carStop',
        meta: {
          title: '途径油站停靠次数统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carPath', //途经道路情况统计
        component: _import('freight/carPath/index'),
        name: 'carPath',
        meta: {
          title: '途经道路情况统计',
          icon: 'widgets'
        }
      },

      /******************** 重点道路运营情况统计 *******************/
      {
        path: 'highSpeedRoad', // 高速
        component: _import('freight/keyRoad/highSpeedRoad/index'),
        name: 'highSpeedRoad',
        meta: {
          title: '高速',
          icon: 'widgets'
        }
      },
      {
        path: 'highSpeedRoadT', // 高速
        component: _import('freight/keyRoadT/highSpeedRoad/index'),
        name: 'highSpeedRoad',
        meta: {
          title: '高速',
          icon: 'widgets'
        }
      },
      {
        path: 'nationalRoad', // 国道
        component: _import('freight/keyRoad/nationalRoad/index'),
        name: 'nationalRoad',
        meta: {
          title: '国道',
          icon: 'widgets'
        }
      },
      {
        path: 'nationalRoadT', // 国道
        component: _import('freight/keyRoadT/nationalRoad/index'),
        name: 'nationalRoad',
        meta: {
          title: '国道',
          icon: 'widgets'
        }
      },
      {
        path: 'highSpeedRoadWeek', // 高速
        component: _import('freight/keyRoadWeek/highSpeedRoad/index'),
        name: 'highSpeedRoadWeek',
        meta: {
          title: '高速',
          icon: 'widgets'
        }
      },
      {
        path: 'nationalRoadWeek', // 国道
        component: _import('freight/keyRoadWeek/nationalRoad/index'),
        name: 'nationalRoadWeek',
        meta: {
          title: '国道',
          icon: 'widgets'
        }
      },
      {
        path: 'highSpeedRoadWeekT', // 高速
        component: _import('freight/keyRoadWeekT/highSpeedRoad/index'),
        name: 'highSpeedRoadWeekT',
        meta: {
          title: '高速(天然气)',
          icon: 'widgets'
        }
      },
      {
        path: 'nationalRoadWeekT', // 国道
        component: _import('freight/keyRoadWeekT/nationalRoad/index'),
        name: 'nationalRoadWeekT',
        meta: {
          title: '国道(天然气)',
          icon: 'widgets'
        }
      },
      {
        path: 'provinceRoad', // 省道
        component: _import('freight/keyRoad/provinceRoad/index'),
        name: 'provinceRoad',
        meta: {
          title: '省道',
          icon: 'widgets'
        }
      },

      {
        path: 'carGas', //加油站停靠统计 真实数据
        component: _import('freight/carGas/index'),
        name: 'carGas',
        meta: {
          title: '加油站停靠统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carLogis', //物流园停靠统计 真实数据
        component: _import('freight/carLogis/index'),
        name: 'carLogis',
        meta: {
          title: '物流园停靠统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carLogisWeek', //物流园停靠统计 真实数据
        component: _import('freight/carLogisWeek/index'),
        name: 'carLogisWeek',
        meta: {
          title: '物流园停靠统计(周)',
          icon: 'widgets'
        }
      },
      {
        path: 'carLogisT', //物流园停靠统计 真实数据
        component: _import('freight/carLogisT/index'),
        name: 'carLogisT',
        meta: {
          title: '物流园停靠统计(天然气)',
          icon: 'widgets'
        }
      },
      {
        path: 'carLogisWeekT', //物流园停靠统计 真实数据
        component: _import('freight/carLogisWeekT/index'),
        name: 'carLogisWeekT',
        meta: {
          title: '物流园停靠统计(天然气)(周)',
          icon: 'widgets'
        }
      },
      {
        path: 'carTonnage', //入网车辆吨位分布 真实数据
        component: _import('freight/carTonnage/index'),
        name: 'carTonnage',
        meta: {
          title: '入网车辆类型分布',
          icon: 'widgets'
        }
      },
      {
        path: 'carOperateTon', //运营车辆吨位分布 真实数据
        component: _import('freight/carOperateTon/index'),
        name: 'carOperateTon',
        meta: {
          title: '运营车辆类型分布',
          icon: 'widgets'
        }
      },
      {
        //milenge
        path: 'carMilenge', //运营车辆行驶里程分布 真实数据
        component: _import('freight/carMilenge/index'),
        name: 'carMilenge',
        meta: {
          title: '运营车辆行驶里程分布',
          icon: 'widgets'
        }
      },
      {
        //milenge
        path: 'carTime', //运营车辆运营时间分布 真实数据
        component: _import('freight/carTime/index'),
        name: 'carTime',
        meta: {
          title: '运营车辆行驶运营时间分布',
          icon: 'widgets'
        }
      },
      {
        path: 'carTrains', //途径各省运营车次统计
        component: _import('freight/carTrains/index'),
        name: 'carTrains',
        meta: {
          title: '途经本省运营车次统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carTrainsDetail', //途径各省运营车次统计 --> 详情
        component: _import('freight/carTrainsDetail/index'),
        name: 'carTrainsDetail',
        meta: {
          title: '途经本省运营车次统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carMileViaProvinceDetail', //途经道路里程情况统计 --> 详情
        component: _import('freight/carMileViaProvinceDetail/index'),
        name: 'carMileViaProvinceDetail',
        meta: {
          title: '途经各类道路运营统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carProvinceMileage', //途经道路里程情况统计
        component: _import('freight/carProvinceMileage/index'),
        name: 'carProvinceMileage',
        meta: {
          title: '途经各类道路运营统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carGasStation', //月均加油站停靠占比统计
        component: _import('freight/carGasStation/index'),
        name: 'carGasStation',
        meta: {
          title: '月均加油站停靠占比统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carStopBrandT', //各省分品牌加油站停靠次数 -途徑省權限/new
        component: _import('freight/carStopBrandT/index'),
        name: 'carStopBrandT',
        meta: {
          title: '各省分品牌加油站停靠次数(天然气)',
          icon: 'widgets'
        }
      },
      {
        path: 'carStopBrandWeekT', //各省分品牌加油站停靠次数 -途徑省權限/new
        component: _import('freight/carStopBrandWeekT/index'),
        name: 'carStopBrandWeekT',
        meta: {
          title: '各省分品牌加油站停靠次数(天然气)(周)',
          icon: 'widgets'
        }
      },
      {
        path: 'carStopBrand', //各省分品牌加油站停靠次数 -途徑省權限/new
        component: _import('freight/carStopBrand/index'),
        name: 'carStopBrand',
        meta: {
          title: '各省分品牌加油站停靠次数',
          icon: 'widgets'
        }
      },
      {
        path: 'carStopBrandWeek', //各省分品牌加油站停靠次数 -途徑省權限/new
        component: _import('freight/carStopBrandWeek/index'),
        name: 'carStopBrandWeek',
        meta: {
          title: '各省分品牌加油站停靠次数(周)',
          icon: 'widgets'
        }
      },
      {
        path: 'carStopXiaBrandWeek', //各省分品牌加油站停靠次数 -途徑省權限/new
        component: _import('freight/carStopBrandWeek/carStopXiaBrand'),
        name: 'carStopXiaBrandWeek',
        meta: {
          title: '本省下辖地区加能站停靠统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carStopXiaBrandWeekT', //各省分品牌加油站停靠次数 -途徑省權限/new
        component: _import('freight/carStopBrandWeekT/carStopXiaBrand'),
        name: 'carStopXiaBrandWeek',
        meta: {
          title: '本省下辖地区加能站停靠统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carStopNengBrandWeek', //各省分品牌加油站停靠次数 -途徑省權限/new
        component: _import('freight/carStopBrandWeek/carStopNengBrand'),
        name: 'carStopNengBrandWeek',
        meta: {
          title: '本省加能站停靠车辆来源省份统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carStopNengBrandWeekT', //各省分品牌加油站停靠次数 -途徑省權限/new
        component: _import('freight/carStopBrandWeekT/carStopNengBrand'),
        name: 'carStopNengBrandWeek',
        meta: {
          title: '本省加能站停靠车辆来源省份统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carStopXiaBrand', //各省分品牌加油站停靠次数 -途徑省權限/new
        component: _import('freight/carStopBrand/carStopXiaBrand'),
        name: 'carStopXiaBrand',
        meta: {
          title: '本省下辖地区加能站停靠统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carStopXiaBrandT', //各省分品牌加油站停靠次数 -途徑省權限/new
        component: _import('freight/carStopBrandT/carStopXiaBrand'),
        name: 'carStopXiaBrand',
        meta: {
          title: '本省下辖地区加能站停靠统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carStopNengBrand', //各省分品牌加油站停靠次数 -途徑省權限/new
        component: _import('freight/carStopBrand/carStopNengBrand'),
        name: 'carStopNengBrand',
        meta: {
          title: '本省加能站停靠车辆来源省份统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carStopNengBrandT', //各省分品牌加油站停靠次数 -途徑省權限/new
        component: _import('freight/carStopBrandT/carStopNengBrand'),
        name: 'carStopNengBrand',
        meta: {
          title: '本省加能站停靠车辆来源省份统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carPriviceBrand', //各省地市分品牌加油站停靠次数统计 /new
        component: _import('freight/carPriviceBrand/index'),
        name: 'carPriviceBrand',
        meta: {
          title: '各省地市分品牌加油站停靠次数统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carPriviceBrandPetrified', //加油站停靠统计-省份权限 /new
        component: _import('freight/carStopBrand/carStopNonPetrified/index'),
        name: 'carPriviceBrandPetrified',
        meta: {
          title: '加油站停靠统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carPriviceBrandPetrifiedT', //加油站停靠统计-省份权限 /new
        component: _import('freight/carStopBrandT/carStopNonPetrified/index'),
        name: 'carPriviceBrandPetrifiedT',
        meta: {
          title: '加油站停靠统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carPriviceBrandPetrifiedWeek', //加油站停靠统计-省份权限 /new
        component: _import('freight/carStopBrandWeek/carStopNonPetrified/index'),
        name: 'carPriviceBrandPetrifiedWeek',
        meta: {
          title: '加油站停靠统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carPriviceBrandPetrifiedWeekT', //加油站停靠统计-省份权限 /new
        component: _import('freight/carStopBrandWeekT/carStopNonPetrified/index'),
        name: 'carPriviceBrandPetrifiedWeek',
        meta: {
          title: '加油站停靠统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carUnpetrifiedCom', //停靠非石化油站企业列表
        component: _import('freight/carUnpetrifiedCom/index'),
        name: 'carUnpetrifiedCom',
        meta: {
          title: '停靠非石化油站企业列表',
          icon: 'widgets'
        }
      },
      {
        path: 'carUnpetrifiedDetail', //停靠非石化油站企业列表 --> 详情
        component: _import('freight/carUnpetrifiedDetail/index'),
        name: 'carUnpetrifiedDetail',
        meta: {
          title: '停靠非石化油站企业详情',
          icon: 'widgets'
        }
      },
      {
        path: 'carStopNonPetrified', //加油站停靠统计-省份权限 /new
        component: _import('freight/carStopNonPetrified/index'),
        name: 'carStopNonPetrified',
        meta: {
          title: '加油站停靠统计',
          icon: 'widgets'
        }
      },
      {
        path: 'carMileViaProvince', //加油站停靠统计-省份权限 /new
        component: _import('freight/carMileViaProvince/index'),
        name: 'carMileViaProvince',
        meta: {
          title: '途经本省运营里程统计',
          icon: 'widgets'
        }
      },
      {
        path: 'weeklyCarOperate',
        component: _import('freight/weekByCarNum/index'),
        name: 'weeklyCarOperate',
        meta: {
          title: '周日均车辆运营情况统计',
          icon: 'widgets'
        }
      },
      {
        path: 'weeklyCarOperateSen',
        component: _import('freight/weekByCarNum/index2'),
        name: 'weeklyCarOperate',
        meta: {
          title: '周日均车辆运营情况统计',
          icon: 'widgets'
        }
      },
      {
        path: 'weeklyBrandGas',
        component: _import('freight/weekByCarStop/index'),
        name: 'weeklyBrandGas',
        meta: {
          title: '周日均车辆加能站停靠统计',
          icon: 'widgets'
        }
      },
      {
        path: 'weeklyBrandGasSen',
        component: _import('freight/weekByCarStop/index2'),
        name: 'weeklyBrandGas',
        meta: {
          title: '周日均车辆加能站停靠统计',
          icon: 'widgets'
        }
      }
    ]
  }
]
export default freight
